import { z } from "zod";

import { ChatWithMembersRecordSchema } from "../../chats/schemas/chat-record.schemas";

/**
 * Send Message to Deployment - Path Variables
 *
 * Validates the deployment ID in the route
 */
export const SendMessagePathVarsSchema = z.object({
  id: z.string().uuid()
});

/**
 * Send Message to Deployment - Request Body
 *
 * Accepts a message, serviceThreadId, and service-specific metadata.
 * Clean architecture: thread ID is separate from metadata (stored in indexed column).
 */
export const SendMessageBodySchema = z.object({
  /** Message content to send */
  message: z.string().min(1).max(50000),

  /**
   * Universal service thread identifier (stored in indexed column)
   * - Email: Gmail thread ID ("1905e0da3164e4f0")
   * - Slack: Channel ID ("D071AHFPV50")
   * - WhatsApp: Phone number ("whatsapp:+32472881419")
   * - Telegram: Chat ID ("6310338700")
   * - etc.
   */
  serviceThreadId: z.string(),

  /**
   * Service-specific context metadata (excludes thread ID)
   * - Email: { subject, from, to }
   * - Slack: { teamId }
   * - WhatsApp: { source: { to } }
   * - etc.
   */
  metadata: z.record(z.string(), z.unknown())
});

/**
 * Send Message to Deployment - Response
 *
 * Returns the chat as `getChatWithMembers` reads it, after the message is written.
 */
export const SendMessageResponseSchema = ChatWithMembersRecordSchema;
